var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4104",
    "data-name": "Rectangle 4104",
    width: 17.107,
    height: 17.103,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11534",
    "data-name": "Group 11534",
    transform: "translate(-1455 -243)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "translate(1455 243)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11533",
    "data-name": "Group 11533",
    transform: "translate(1461.304 249.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11197",
    "data-name": "Group 11197",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M17.049,3.484a2.142,2.142,0,0,0-.616-1.054c-.423-.415-.84-.838-1.26-1.256C14.95.953,14.728.73,14.5.515A1.994,1.994,0,0,0,12.234.226a2.816,2.816,0,0,0-.689.538Q9.288,3.015,7.034,5.27L1.791,10.511q-.562.562-1.12,1.127a.661.661,0,0,0-.2.4c-.021.2-.042.393-.064.589-.047.417-.1.834-.142,1.251s-.094.855-.141,1.283Q.063,15.735,0,16.308H.006v.032a.686.686,0,0,0,.806.757q.342-.032.684-.069c.505-.055,1.01-.112,1.514-.168.652-.073,1.3-.149,1.956-.218a.8.8,0,0,0,.515-.238c.115-.119.242-.227.359-.344q.9-.892,1.791-1.787,1.5-1.5,3-3,1.62-1.615,3.242-3.228.825-.824,1.64-1.655c.359-.364.729-.72,1.067-1.1a1.937,1.937,0,0,0,.465-1.8m-1.315.555a.676.676,0,0,1-.195.39l-.829.833L13.9,6.08l-.006.006-.406.407-.015.014L12.4,7.578l-.018.019L12,7.978,8.449,11.525q-1.813,1.811-3.622,3.626a.59.59,0,0,1-.375.188c-.421.043-.841.095-1.262.142-.35.04-.7.08-1.051.116-.214.023-.428.041-.643.06a.3.3,0,0,1-.058-.008c.053-.458.1-.9.155-1.347.031-.273.06-.547.09-.82.036-.329.068-.659.11-.988a.274.274,0,0,1,.08-.142c.568-.569,1.14-1.136,1.709-1.705l5.7-5.7h0L10.531,3.7h0l.218-.216.006-.006.359-.356L12.528,1.7c.055-.055.111-.109.17-.159a.65.65,0,0,1,.911.006c.16.143.31.3.462.451q.719.719,1.437,1.438a.682.682,0,0,1,.227.6",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M167.439,69.35l.047-.058-2.868-2.871c-.052.051-.094.092-.136.134l-.162.163h0l1.247-1.247,2.869,2.873c.023-.021.047-.042.07-.064Z",
    transform: "translate(-155.037 -61.771)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.0ea150a810557ee6f2e7e2b73feb33c4.svg";
export { ForwardRef as ReactComponent };